import { BreadcrumbSuffix } from './Breadcrumbs.types'

export const types = {
  setSuffix: '@breadcrumbs/setSuffix'
}

export function setSuffix({ suffix = [] }: { suffix?: BreadcrumbSuffix[] }) {
  return { type: types.setSuffix, payload: { suffix } }
}
